<!-- See app/modules/general/scss/_loader.scss -->
<div class="full-screen-loader"><div /></div>
